import styled from 'styled-components';

import InfoSVG from '../../../../assets/icons/help.svg';
import {getColor, getRem, ms, square} from '../../../../styles';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const TitleContainer = styled(View)`
  flex: 1;
  justify-content: center;
  align-items: center;
  column-gap: ${ms(4)};
`;

export const Title = styled(Text).attrs({weight: 'semibold'})`
  text-align: left;
  font-size: ${getRem(24)};
`;

export const InfoIcon = styled(InfoSVG).attrs(p => ({
  fill: getColor('icon4')(p),
}))`
  ${square(30)};
`;

export const TooltipBody = styled(View)`
  flex-direction: column;
  row-gap: ${ms(16)};
  width: ${ms(280)};
`;

export const TooltipTitle = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${getRem(16)};
`;

export const TooltipContent = styled(Text)``;
